/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type SkillLevelDropdown_company$ref: FragmentReference;
declare export opaque type SkillLevelDropdown_company$fragmentType: SkillLevelDropdown_company$ref;
export type SkillLevelDropdown_company = {|
  +skillLevels: ?$ReadOnlyArray<?{|
    +id: string,
    +level: ?number,
    +description: ?string,
  |}>,
  +$refType: SkillLevelDropdown_company$ref,
|};
export type SkillLevelDropdown_company$data = SkillLevelDropdown_company;
export type SkillLevelDropdown_company$key = {
  +$data?: SkillLevelDropdown_company$data,
  +$fragmentRefs: SkillLevelDropdown_company$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SkillLevelDropdown_company",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "SkillLevel",
      "kind": "LinkedField",
      "name": "skillLevels",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "level",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "description",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Company"
};
// prettier-ignore
(node/*: any*/).hash = 'cb98250d357f9d3e31120740082b39a0';

module.exports = node;
